import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) return setError("Passwords do not match");
    if (password.length < 6) return setError("Password must be at least 6 characters");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/auth?tab=login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Navbar />
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md rounded-lg border tf-hairline bg-white p-8">
          <h1 className="font-[Chivo] text-3xl font-black text-[#0A2540]">Choose a new password</h1>
          <p className="text-slate-600 mt-2">Enter your reset token and new password.</p>
          <form onSubmit={submit} className="mt-6 space-y-5" data-testid="reset-form">
            <div>
              <Label>Reset token</Label>
              <Input required value={token} onChange={(e) => setToken(e.target.value)} className="mt-1 font-mono text-xs" data-testid="reset-token" />
            </div>
            <div>
              <Label>New password</Label>
              <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" data-testid="reset-password" />
            </div>
            <div>
              <Label>Confirm password</Label>
              <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1" data-testid="reset-confirm" />
            </div>
            {error && <div className="text-sm text-[#D32F2F] bg-[#D32F2F]/10 rounded px-3 py-2" data-testid="reset-error">{error}</div>}
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[#D32F2F]" data-testid="reset-submit">{loading ? "Saving…" : "Reset password"}</Button>
          </form>
          <div className="mt-6 text-sm text-slate-600"><Link to="/auth?tab=login" className="text-[#0A2540] font-semibold">Back to sign in</Link></div>
        </div>
      </div>
    </div>
  );
}
